import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "../lib/firebase.js";

const MAX_BYTES = 8 * 1024 * 1024; // 8MB, matches admin UI copy

/* Upload an image File to `path/{timestamp-filename}`. Calls onProgress(0..100).
   Returns { url, storagePath }. Store both so a later replace/delete can clean up. */
export async function uploadImage(path, file, onProgress) {
  if (!file.type.startsWith("image/")) {
    throw new Error("Please choose an image file (PNG or JPG).");
  }
  if (file.size > MAX_BYTES) {
    throw new Error("Image is too large. Maximum size is 8MB.");
  }
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
  const fullPath = `${path.replace(/\/$/, "")}/${Date.now()}-${safeName}`;
  const storageRef = ref(storage, fullPath);
  const task = uploadBytesResumable(storageRef, file, { contentType: file.type });

  return new Promise((resolve, reject) => {
    task.on(
      "state_changed",
      (snap) => {
        if (onProgress) {
          onProgress(Math.round((snap.bytesTransferred / snap.totalBytes) * 100));
        }
      },
      reject,
      async () => {
        const url = await getDownloadURL(task.snapshot.ref);
        resolve({ url, storagePath: fullPath });
      }
    );
  });
}

/* Best-effort delete of a previously uploaded object. Safe to call with null. */
export async function deleteImage(storagePath) {
  if (!storagePath) return;
  try {
    await deleteObject(ref(storage, storagePath));
  } catch (err) {
    // Missing object or permission race — log and move on.
    console.warn("[storage] deleteImage failed", storagePath, err.code || err.message);
  }
}
